/* Confirmed French Days offer: copy its code and retire messages at the deadline. */
(function () {
  'use strict';
  var notices = Array.from(document.querySelectorAll('.announcement-v7[data-promo-end], .home-banner-promo[data-promo-end]'));
  if (!notices.length) return;
  var timer;
  function refresh() {
    window.clearTimeout(timer);
    var next = Infinity;
    var now = Date.now();
    notices.forEach(function (notice) {
      var end = Date.parse(notice.dataset.promoEnd);
      if (!Number.isFinite(end)) return;
      var expired = notice.dataset.promoEnded === 'true' || now >= end;
      if (notice.hasAttribute('data-promo-hide-on-expiry')) notice.hidden = expired;
      else {
        var promo = notice.querySelector('[data-promo-live]');
        var fallback = notice.querySelector('[data-promo-fallback]');
        if (promo) promo.hidden = expired;
        if (fallback) fallback.hidden = !expired;
      }
      if (expired) notice.dataset.promoEnded = 'true';
      else next = Math.min(next, end - now);
    });
    if (Number.isFinite(next)) timer = window.setTimeout(refresh, Math.min(next + 25, 2147483647));
  }
  function legacyCopy(code) {
    var field = document.createElement('textarea');
    field.value = code;
    field.readOnly = true;
    field.tabIndex = -1;
    field.style.cssText = 'position:fixed;left:-9999px;top:0;font-size:16px;';
    field.setAttribute('aria-hidden', 'true');
    document.body.appendChild(field);
    field.select();
    var copied = false;
    try { copied = document.execCommand('copy') === true; } catch (_) {}
    field.remove();
    return copied;
  }
  var resetTimers = new WeakMap();
  document.addEventListener('click', async function (event) {
    var button = event.target.closest && event.target.closest('[data-promo-code]');
    if (!button || button.dataset.copyBusy === 'true') return;
    var notice = button.closest('[data-promo-end]');
    if (!notice || notice.dataset.promoEnded === 'true' || Date.now() >= Date.parse(notice.dataset.promoEnd)) {
      refresh();
      return;
    }
    var code = button.dataset.promoCode;
    if (code !== 'FRENCH20') return;
    button.dataset.copyBusy = 'true';
    button.setAttribute('aria-busy', 'true');
    var copied = false;
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(code);
        copied = true;
      } else copied = legacyCopy(code);
    } catch (_) { copied = legacyCopy(code); }
    delete button.dataset.copyBusy;
    button.removeAttribute('aria-busy');
    button.focus({ preventScroll: true });
    var status = notice.querySelector('[data-promo-copy-status]');
    var label = button.querySelector('[data-promo-code-label]');
    window.clearTimeout(resetTimers.get(button));
    if (copied) {
      if (status) status.textContent = 'Code FRENCH20 copié.';
      if (label) label.textContent = 'Copié ✓';
      button.dataset.copied = 'true';
      button.setAttribute('aria-label', 'Code FRENCH20 copié');
      resetTimers.set(button, window.setTimeout(function () {
        if (label) label.textContent = code;
        delete button.dataset.copied;
        button.setAttribute('aria-label', 'Copier le code FRENCH20');
        if (status) status.textContent = '';
      }, 2200));
    } else {
      if (status) status.textContent = 'Copie indisponible. Le code à saisir est FRENCH20.';
      if (label) label.textContent = code;
      delete button.dataset.copied;
      button.setAttribute('aria-label', 'Copier le code FRENCH20');
    }
  });
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
  refresh();
}());
